import {connect} from 'react-redux';
import {createSelector} from 'reselect';

import {AsyncStatusesEnum} from '../../../libs/shared/helpers/src/types/asyncStatuses';
import {makeMapDispatchToProps, makeMapStateToProps} from '../../helpers/reselectHelpers';
import {AppState} from '../../store/appState';
import {makeGetReplyChannel} from '../../store/data/channels/channelsSelectors';
import {getMessages} from '../../store/data/dataSelectors';
import {getUser} from '../../store/data/teammates/teammatesSelectors';
import {makeDefaultCellsContext} from '../../store/panels/cells/context/cellsContext';
import {retryEmlAsyncAction} from '../../store/panels/eml/emlPanelActions';
import {EmlPanelId} from '../../store/panels/panelStateBase';
import {PopupEml} from './popupEml';

/*
 * Props.
 */

interface PopupEmlContainerProps {
  panelId: EmlPanelId;
  status: AsyncStatusesEnum;
  messageUid: string | undefined;
}

/*
 * Selectors.
 */

function getMessageUid(_state: AppState, props: PopupEmlContainerProps) {
  return props.messageUid;
}

function makeGetMessage() {
  return createSelector([getMessages, getMessageUid], (messages, messageUid) => {
    if (!messageUid) {
      return undefined;
    }

    return messages[messageUid];
  });
}

/*
 * Redux.
 */

// TODO: Replace with shared instance.
const getDefaultCellsContext = createSelector(getUser, (user) => makeDefaultCellsContext(user, false));

const mapStateToProps = makeMapStateToProps<PopupEmlContainerProps>()(() => {
  const getMessage = makeGetMessage();
  const getSelectedInboxId = () => undefined;
  const getReplyChannel = makeGetReplyChannel({getMessage, getSelectedInboxId});

  return {
    message: getMessage,
    cellsContext: getDefaultCellsContext,
    replyChannel: getReplyChannel,
  };
});

const mapDispatchToProps = makeMapDispatchToProps<PopupEmlContainerProps>()(({panelId}) => ({
  onRetryClick: () => retryEmlAsyncAction(panelId),
}));

export const PopupEmlContainer = connect(mapStateToProps, mapDispatchToProps)(PopupEml);
